import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Scroll from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilterCircleXmark,
  faArrowLeft,
  faTachometer,
  faPlus,
  faRefresh,
  faFilter,
  faSearch,
  faBook,
  faTable,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { useRecoilState } from "recoil";

import FormInputFieldWithButton from "../Reusable/FormInputFieldWithButton";
import FormSelectField from "../Reusable/FormSelectField";
import {
  topAlertMessageState,
  topAlertStatusState,
  usersShowFilterState,
  usersSearchTextState,
  usersTrialStatusState,
  usersCreatedState,
} from "../../AppState";
import { DEFAULT_USER_LIST_SORT_BY_VALUE } from "../../Constants/App";
import {
  USER_CREATED_LIST_OPTIONS,
  RESOURCETYPE_LIST_OPTIONS,
} from "../../Constants/FieldOptions";
import ResourcesList from "./List";
import { getResourcesListAPI } from "../../API/Resource";
import FormErrorBox from "../Reusable/FormErrorBox";
import PageLoadingContent from "../Reusable/PageLoadingContent";
import ResourcesMobileList from "./list-mobile";

//TODO: IMPLEMENT.
function Resources() {
  ////
  //// Global state.
  ////

  const [topAlertMessage, setTopAlertMessage] =
    useRecoilState(topAlertMessageState);
  const [topAlertStatus, setTopAlertStatus] =
    useRecoilState(topAlertStatusState);
  const [showFilter, setShowFilter] = useRecoilState(usersShowFilterState);
  const [temporarySearchText, setTemporarySearchText] =
    useRecoilState(usersSearchTextState); // The search field value as your writes their query.
  const [trialStatus, setTrialStatus] = useRecoilState(usersTrialStatusState); // Filtering
  const [created, setCreated] = useRecoilState(usersCreatedState); // Filtering

  ////
  //// Component states.
  ////

  const [errors, setErrors] = useState({});
  const [users, setUsers] = useState("");
  const [isFetching, setFetching] = useState(false);
  const [actualSearchText, setActualSearchText] = useState(temporarySearchText); // The actual search query value to submit to the API.
  const [sortByValue, setSortByValue] = useState(
    DEFAULT_USER_LIST_SORT_BY_VALUE
  ); // Sorting
  const [listData, setListData] = useState(""); // List Data + Pagination
  const [pageSize, setPageSize] = useState(25); // Pagination
  const [previousCursors, setPreviousCursors] = useState([]); // Pagination
  const [nextCursor, setNextCursor] = useState(""); // Pagination
  const [currentCursor, setCurrentCursor] = useState(""); // Pagination

  ////
  //// API.
  ////

  function onUserListSuccess(response) {
    console.log("onUserListSuccess: Starting...");
    setListData(response);
    if (response.hasNextPage) {
      setNextCursor(response.nextCursor); // For pagination purposes.
    }
  }

  function onUserListError(apiErr) {
    console.log("onUserListError: Starting...");
    setErrors(apiErr);

    // The following code will cause the screen to scroll to the top of
    // the page. Please see ``react-scroll`` for more information:
    // https://github.com/fisshy/react-scroll
    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onUserListDone() {
    console.log("onUserListDone: Starting...");
    setFetching(false);
  }

  function onUserDeleteSuccess(response) {
    console.log("onUserDeleteSuccess: Starting..."); // For debugging purposes only.

    // Update notification.
    setTopAlertStatus("success");
    setTopAlertMessage("User deleted");
    setTimeout(() => {
      console.log(
        "onDeleteConfirmButtonClick: topAlertMessage, topAlertStatus:",
        topAlertMessage,
        topAlertStatus
      );
      setTopAlertMessage("");
    }, 2000);

    // Fetch again an updated list.
    defaultFetchList();
  }

  function onUserDeleteError(apiErr) {
    console.log("onUserDeleteError: Starting..."); // For debugging purposes only.
    setErrors(apiErr);

    // Update notification.
    setTopAlertStatus("danger");
    setTopAlertMessage("Failed deleting");
    setTimeout(() => {
      console.log(
        "onUserDeleteError: topAlertMessage, topAlertStatus:",
        topAlertMessage,
        topAlertStatus
      );
      setTopAlertMessage("");
    }, 2000);

    // The following code will cause the screen to scroll to the top of
    // the page. Please see ``react-scroll`` for more information:
    // https://github.com/fisshy/react-scroll
    var scroll = Scroll.animateScroll;
    scroll.scrollToTop();
  }

  function onUserDeleteDone() {
    console.log("onUserDeleteDone: Starting...");
    setFetching(false);
  }

  ////
  //// Event handling.
  ////

  const onClearFilterClick = (e) => {
    setShowFilter(false);
    setActualSearchText("");
    setTemporarySearchText("");
    setTrialStatus(null);
    setCreated(368); // Last year
  };

  const onSearchButtonClick = (e) => {
    console.log("Search button clicked...");
    setActualSearchText(temporarySearchText);
  };

  const defaultFetchList = () => {
    fetchList(
      actualSearchText,
      trialStatus,
      currentCursor,
      pageSize,
      created,
      sortByValue
    );
  };

  const fetchList = (keywords, ts, cur, limit, cdr, sbv) => {
    // Include pagination support.
    setFetching(true);
    setErrors({});

    let params = new Map();
    if (keywords !== undefined && keywords !== null && keywords !== "") {
      params.set("search", keywords);
    }
    if (ts !== undefined && ts !== null && ts !== "") {
      params.set("categoryName", ts);
    }

    params.set("page_size", limit); // Pagination

    if (cur !== "") {
      params.set("cursor", cur); // Pagination
    }

    // DEVELOPERS NOTE: Our `sortByValue` is string with the sort field
    // and sort order combined with a comma seperation. Therefore we
    // need to split as follows.
    if (sbv !== undefined && sbv !== null && sbv !== "") {
      const sortArray = sbv.split(",");
      params.set("sort_field", sortArray[0]); // Sort (1 of 2)
      params.set("sort_order", sortArray[1]); // Sort (2 of 2)
    }
    if (cdr !== undefined && cdr !== null && cdr !== "") {
      let end = Math.floor(Date.now() / 1000); // Current unix time.

      let start = end - cdr * 24 * 60 * 60; // Subtracting cdr days in seconds.

      console.log("days:", cdr, "start:", start, "end:", end);

      // const [cs, ce] = cdr;
      params.set("created_gte", start); // Sort (1 of 2)
      params.set("created_lte", end); // Sort (2 of 2)
    }

    // Fetch data.
    getResourcesListAPI(
      params,
      onUserListSuccess,
      onUserListError,
      onUserListDone
    );
  };

  const onNextClicked = (e) => {
    console.log("onNextClicked");
    let arr = [...previousCursors];
    arr.push(currentCursor);
    setPreviousCursors(arr);
    setCurrentCursor(nextCursor);
  };

  const onPreviousClicked = (e) => {
    console.log("onPreviousClicked");
    let arr = [...previousCursors];
    const previousCursor = arr.pop();
    setPreviousCursors(arr);
    setCurrentCursor(previousCursor);
  };

  ////
  //// Misc.
  ////

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      window.scrollTo(0, 0);
      fetchList(
        actualSearchText,
        trialStatus,
        currentCursor,
        pageSize,
        created,
        sortByValue
      );
    }

    return () => {
      mounted = false;
    };
  }, [
    actualSearchText,
    trialStatus,
    currentCursor,
    pageSize,
    created,
    sortByValue,
  ]);

  ////
  //// Component rendering.
  ////

  console.log("created:", created);

  return (
    <>
      <div class="container">
        <section class="section">
          {/* Desktop Breadcrumbs */}
          <nav class="breadcrumb is-hidden-touch" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to="/dashboard">
                  <FontAwesomeIcon className="fas" icon={faTachometer} />
                  &nbsp;Dashboard
                </Link>
              </li>
              <li class="is-active">
                <Link to="/users" aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faBook} />
                  &nbsp;resources
                </Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Breadcrumbs */}
          <nav class="breadcrumb is-hidden-desktop" aria-label="breadcrumbs">
            <ul>
              <li class="">
                <Link to={`/dashboard`} aria-current="page">
                  <FontAwesomeIcon className="fas" icon={faArrowLeft} />
                  &nbsp;Back to Dashboard
                </Link>
              </li>
            </ul>
          </nav>

          {/* Model(s) */}
          {/* None in this page */}

          {/* Content */}
          <nav class="box">
            <div class="columns">
              <div class="column">
                <h1 class="title is-4">
                  <FontAwesomeIcon className="fas" icon={faBook} />
                  &nbsp;resources
                </h1>
              </div>
              {/* {!isFetching && ( */}
              <div class="column has-text-right">
                <button
                  class="button is-small is-info is-fullwidth-mobile"
                  onClick={defaultFetchList}
                >
                  <FontAwesomeIcon className="mdi" icon={faRefresh} />
                  <span class="is-hidden-desktop is-hidden-tablet">
                    &nbsp;Refresh
                  </span>
                </button>
                &nbsp;
                <button
                  onClick={(e, i) => {
                    setShowFilter(!showFilter);
                  }}
                  class="button is-small is-link is-fullwidth-mobile"
                  type="button"
                >
                  <FontAwesomeIcon className="mdi" icon={faFilter} />
                  &nbsp;Filter
                </button>
                &nbsp;
                <Link
                  class="button is-small is-success is-fullwidth-mobile"
                  type="button"
                >
                  <FontAwesomeIcon className="mdi" icon={faPlus} />
                  &nbsp;New Resource
                </Link>
              </div>
              {/* )} */}
            </div>

            {/* Filter Box */}
            {showFilter && (
              <>
                <div
                  class="has-background-white-bis"
                  style={{ borderRadius: "15px", padding: "20px" }}
                >
                  {/* Filter Title + Clear Button */}
                  <div class="columns">
                    <div class="column is-half">
                      <strong>
                        <u>
                          <FontAwesomeIcon className="mdi" icon={faFilter} />
                          &nbsp;Filter
                        </u>
                      </strong>
                    </div>
                    <div class="column is-half has-text-right">
                      <Link onClick={onClearFilterClick}>
                        <FontAwesomeIcon
                          className="mdi"
                          icon={faFilterCircleXmark}
                        />
                        &nbsp;Clear Filter
                      </Link>
                    </div>
                  </div>

                  {/* Filter Options */}
                  <div class="columns">
                    <div class="column is-half">
                      <FormInputFieldWithButton
                        label={"Search"}
                        name="temporarySearchText"
                        type="text"
                        placeholder="Search by Title"
                        value={temporarySearchText}
                        helpText=""
                        onChange={(e) => setTemporarySearchText(e.target.value)}
                        isRequired={true}
                        maxWidth="100%"
                        buttonLabel={
                          <>
                            <FontAwesomeIcon className="fas" icon={faSearch} />
                          </>
                        }
                        onButtonClick={onSearchButtonClick}
                      />
                    </div>
                    <div class="column">
                      <div class="">
                        <FormSelectField
                          label="Filter by Category"
                          name="Filter Category"
                          placeholder="Text input"
                          selectedValue={trialStatus}
                          options={RESOURCETYPE_LIST_OPTIONS}
                          errorText={errors && errors.trialStatus}
                          helpText=""
                          onChange={(e) => setTrialStatus(e.target.value)}
                          maxWidth="150px"
                        />
                      </div>
                    </div>
                    <div class="column">
                      <FormSelectField
                        label="Created"
                        name="created"
                        placeholder="Text input"
                        selectedValue={parseInt(created)}
                        options={USER_CREATED_LIST_OPTIONS}
                        errorText={errors && errors.created}
                        helpText=""
                        onChange={(e) => setCreated(parseInt(e.target.value))}
                        maxWidth="150px"
                      />
                    </div>
                  </div>
                </div>
              </>
            )}

            {isFetching ? (
              <>
                <PageLoadingContent displayMessage={"Please wait"} />
              </>
            ) : (
              <>
                <FormErrorBox errors={errors} />
                {listData &&
                (listData.length > 0 || previousCursors.length > 0) ? (
                  <div class="container">
                    {/* ##################################################################
                    EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A DESKTOP
                    SCREEN.
                    ################################################################## */}
                    <div class="is-hidden-touch">
                      <ResourcesList
                        listData={listData}
                        setPageSize={setPageSize}
                        pageSize={pageSize}
                        previousCursors={previousCursors}
                        onPreviousClicked={onPreviousClicked}
                        onNextClicked={onNextClicked}
                      />
                    </div>
                    {/* ###########################################################################
                    EVERYTHING INSIDE HERE WILL ONLY BE DISPLAYED ON A TABLET OR
                    MOBILE SCREEN.
                    ########################################################################### */}
                    <div class="is-fullwidth is-hidden-desktop">
                      <ResourcesMobileList
                        listData={listData}
                        setPageSize={setPageSize}
                        pageSize={pageSize}
                        previousCursors={previousCursors}
                        onPreviousClicked={onPreviousClicked}
                        onNextClicked={onNextClicked}
                      />
                    </div>
                  </div>
                ) : (
                  <div class="hero-body">
                    <p class="title">
                      <FontAwesomeIcon className="fas" icon={faTable} />
                      &nbsp;No data
                    </p>
                    <p class="subtitle">
                      No data.
                      <b>
                        <Link to="/users/add">
                          Click here&nbsp;
                          <FontAwesomeIcon
                            className="mdi"
                            icon={faArrowRight}
                          />
                        </Link>
                      </b>
                      to get started creating your first user.
                    </p>
                  </div>
                )}
              </>
            )}
          </nav>
        </section>
      </div>
    </>
  );
}

export default Resources;
